<ui-icon icon="manual" [size]="size" [class.icon-platform-muted]="muted" [class.icon-platform-white]="white"></ui-icon>
